import React from 'react'
import '../css/copyright2.css'

const Copyright2 = () => {

    const d = new Date();
    let year = d.getFullYear(); 


    return (
    <>

    <div className='copy-cont'>
          <div className='copy-inner'><h5 style={{ marginTop: '2px' }}>&copy; GALANTIS { year }</h5></div>
    </div>


    </>
    )
}

export default Copyright2